import { languageCodes } from "./langUtils";

// ========= VALIDATION FUNCTION =========
export function validateQueryParams({ surveyId, panelistId, lang }) {
  // Helper to remove anything that's not a digit
  const stripToDigits = (val) => (val ? val.replace(/\D/g, "") : "");

  // Normalize language code
  const normalizedLang = lang?.trim().toLowerCase() || "";

  const allowedCodes = Object.values(languageCodes);
  const langValid = allowedCodes.includes(normalizedLang);

  const surveyHasDigits = Boolean(surveyId && /\d/.test(surveyId));
  const panelistHasDigits = Boolean(panelistId && /\d/.test(panelistId));

  const surveyValid = surveyHasDigits;
  const panelistValid = panelistHasDigits;

  const overallValid = surveyValid && panelistValid && langValid;

  // Only strip if everything is valid
  const finalSurveyId = overallValid ? stripToDigits(surveyId) : surveyId;
  const finalPanelistId = overallValid ? stripToDigits(panelistId) : panelistId;

  return {
    valid: overallValid,
    surveyId: finalSurveyId,
    panelistId: finalPanelistId,
    lang: normalizedLang,
    errors: {
      surveyId: !surveyValid ? "Invalid or missing surveyId" : null,
      panelistId: !panelistValid ? "Invalid or missing panelistId" : null,
      lang: !langValid ? "Invalid or unsupported language code" : null,
    },
  };
}